module.exports = __webpack_public_path__ + "img/IMG_1401_L_WoodMatted_MockedUp.2f24a770.jpg";